<template>
    <div :class="$style['related-comp']" ref="root">
        <product-gallery
            v-if="
                product.relatedProductsUrl != null &&
                product.relatedProductsUrl != '' &&
                visible
            "
            :products-per-row="productsPerRow"
            :fetch-url="product.relatedProductsUrl"
        >
            <template #top-part>
                <div :class="$style['header']">
                    {{
                        labels.frontendProductpage.shop
                            .recommendedProductsHeader
                    }}
                </div>
            </template>
        </product-gallery>
    </div>
</template>

<style module lang="scss">
@import "../../../../responsive/style.scss";

.related-comp {
    min-height: 375px;
    @include media-breakpoint-up(lg) {
        min-height: 365px;
    }
}

.header {
    text-align: center;
    flex: 1;
    color: #000000;
    font-family: "Open Sans";
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
    margin-top: 40px;

    @include media-breakpoint-up(lg) {
        font-size: 25px;
    }
}
</style>

<script setup lang="ts">
import {
    type PropType,
    computed,
    defineAsyncComponent,
    ref,
    onMounted,
} from "vue";
const productGallery = defineAsyncComponent(
    () =>
        import(
            /* webpackFetchPriority: "high" */
            "../../frontend-productgallery/ProductGallery.vue"
        )
);
import labels from "../../shared/labels";
import { type ShopProduct } from "./types";
import { getBreakpointObservable } from "../../../../shared/breakpoint-observable";
import { elementVisible } from "../../frontend-productgallery/element-intersection";

defineProps({
    product: {
        type: Object as PropType<ShopProduct>,
        required: true,
    },
});

const visible = ref(false);

const breakpointObserver = getBreakpointObservable();

const currentBreakpoint = computed(() => {
    return breakpointObserver.currentBreakpoint;
});
const productsPerRow = computed(() => {
    if (currentBreakpoint.value?.up("lg") == true) return 5;
    return 2;
});

const intersectionObserver = ref<IntersectionObserver>();

const interscetionCallback: IntersectionObserverCallback = (entries) => {
    entries.forEach((x) => {
        if ((visible.value = x.intersectionRatio > 0)) {
            console.log("now visible");
            intersectionObserver.value?.disconnect();
        }
    });
};

const root = ref<HTMLDivElement>();

onMounted(() => {
    if (
        root.value != null &&
        root.value instanceof HTMLElement
    ) {
        if (elementVisible(root.value)) {
            visible.value = true;
        } else {
            const options: IntersectionObserverInit = {
                root: document.body,
                rootMargin: "0px",
                threshold: 1.0,
            };

            intersectionObserver.value = new IntersectionObserver(
                interscetionCallback,
                options
            );
            intersectionObserver.value.observe(root.value);
        }
    }
});
</script>
